module.exports = __webpack_public_path__ + "img/bicycle-orange.6b6e6dc2.svg";